<template>
  <div
    class="w-100 d-flex flex-column gap-4 justify-center align-center my-10"
    data-testid="yard-no-gm-enabled-message">
    <span class="icon-wrapper">
      <v-icon class="icon" size="50" color="#9E9E9E">mdi-domain-off</v-icon>
    </span>
    <div style="max-inline-size: 270px; text-align: center">
      <h3 class="typography-body-md-bold align-center mb-8">
        {{ t('yard.messages.gateManagementIsNotEnabledForThisWarehouse') }}
      </h3>
      <p>
        <i18n-t keypath="yard.messages.upgradeToGainAccessToYardManagement">
          <template #strongText>
            <strong>{{ t('global.specialtyTerms.gateManagement') }}</strong>
          </template>
        </i18n-t>
      </p>
    </div>
    <p class="typography-body-sm m-0">
      {{ t('yard.messages.interested') }}
      <a
        href="https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In"
        target="_blank">
        {{ t('global.phrases.learnHowItWorks') }}
      </a>
      {{ t('yard.messages.orContactUsTo') }}
      <a href="https://lp.opendock.com/gate-management" target="_blank">
        {{ t('yard.messages.requestATrial') }}
      </a>
    </p>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewGmDisabled',
  setup() {
    const { t } = useI18n();

    return { t };
  }
});
</script>

<style lang="scss" scoped>
.icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  inline-size: 96px;
  block-size: 96px;

  border: 1px solid $color-line-border;
  border-radius: 50%;
  background-color: $color-neutral-20;
}
</style>
